import React, { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2, SearchField } from '@/components/custom/erp';
import { initialSearchValues, SearchFormSchema } from '../schema';
import { nhomColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { Group } from '@/types/schemas';

interface SearchDialogProps {
  openSearchDialog: boolean;
  onCloseSearchDialog: () => void;
  onSearch: (uuid: string) => Promise<unknown>;
}

const SearchDialog = ({ openSearchDialog, onCloseSearchDialog, onSearch }: SearchDialogProps) => {
  const [loaiNhom, setLoaiNhom] = useState<Group | null>(null);

  const handleSubmit = async () => {
    if (!loaiNhom) return;

    try {
      await onSearch(loaiNhom.ma_nhom);
      onCloseSearchDialog();
    } catch (error: unknown) {
      console.error(error);
    }
  };

  return (
    <DialogV2
      open={openSearchDialog}
      onClose={onCloseSearchDialog}
      title='Danh mục phân nhóm (Lọc)'
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={SearchFormSchema}
        onSubmit={handleSubmit}
        initialData={initialSearchValues}
        className='w-[900px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <div className='space-y-2 p-4'>
              <div className='space-y-1'>
                <div className='flex items-center'>
                  <Label className='w-32 min-w-32'>Loại nhóm</Label>
                  <SearchField<Group>
                    type='text'
                    searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${loaiNhom?.loai_nhom}`}
                    searchColumns={nhomColumns}
                    dialogTitle='Danh mục loại nhóm'
                    className='w-[250px]'
                    classNameRelatedField='w-full'
                    columnDisplay='ma_nhom'
                    displayRelatedField='ten_phan_nhom'
                    onRowSelection={setLoaiNhom}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='add' onClose={onCloseSearchDialog} onAdd={handleSubmit} />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
